'use client'
import { useState } from 'react'
import Image from 'next/image'
import { RefinementList } from 'react-instantsearch'
import '@/components/layout/search/search.css'

interface IProps {
  filterToExclude?: string
  isHomePage?: boolean
}

const FILTERS = [
  { label: 'REGION', filterby: 'region', searchable: false },
  { label: 'STATE', filterby: 'state', searchable: true },
  { label: 'STATUS', filterby: 'status', searchable: false },
  { label: 'UNIVERSITY', filterby: 'universities.acronym', searchable: true },
  { label: 'ORGANIZATION', filterby: 'organizations.name', searchable: true },
]
const Filters = ({ filterToExclude, isHomePage = false }: IProps) => {
  const [openFilter, setOpenFilter] = useState<string | null>(null)
  const toggleFilter = (filterId: string) => {
    if (openFilter === filterId) {
      setOpenFilter(null)
    } else {
      setOpenFilter(filterId)
    }
  }

  const toggleCloseFilters = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!(event.target.className === 'ais-SearchBox-input')) setOpenFilter('0')
  }
  return (
    <div className={`mt-[8px] min-w-full ${isHomePage ? 'justify-center' : ''} sm:flex-row flex-col flex `}>
      {FILTERS.map((item, index) => {
        if (filterToExclude === item.filterby) {
          return null
        }
        return (
          <div
            key={index}
            className={`${
              item.filterby === openFilter ? '!border-feYellow shadow-sm' : '!border-gray-600'
            } flex flex-col border   rounded-[10px] sm:mr-[8px] mb-[10px] `}
          >
            <button
              className={` ${
                item.filterby === openFilter ? 'bg-feYellow text-black' : 'bg-white  !text-gray-600'
              }  flex items-center font-semibold p-[5px]	justify-between   sm:mb-[0px]   rounded-[10px] shadow-sm focus:border-none focus:outline-none italic`}
              onClick={() => toggleFilter(item.filterby)}
            >
              <div>{item.label}</div>
              <Image
                alt="arrow_icon"
                width={18}
                height={6}
                className={'w-4 h-2 ml-1'}
                src={`/images/favicons/filter_arrow${
                  openFilter === item.filterby ? '_checked' : ''
                }.svg`}
              />
            </button>
            <div
              className={` ${
                openFilter === item.filterby ? 'block' : 'hidden'
              } bg-white z-[1] h-[200px] sm:w-[200px] w-[300px] rounded-[5px]  shadow-sm mt-[38px] absolute overflow-y-auto pt-[5px] pb-[10px] border border-gray-600 scrollInner `}
              id={item.filterby}
            >
              <RefinementList
                onChange={(ev: React.ChangeEvent<HTMLInputElement>) => toggleCloseFilters(ev)}
                attribute={item.filterby}
                operator="or"
                limit={250}
                searchable={item.searchable}
                searchablePlaceholder="Search..."
                sortBy={['name:asc']}
                classNames={{
                  label: `text-sm`,
                  count: 'hidden',
                  item: 'flex ml-[10px] cursor-pointer items-center text-gray-600 line-clamp-1',
                  checkbox:
                    'focus:outline-none checked:bg-none focus:ring-0 appearance-none h-[11px] w-[11px] bg-[#D9D9D9] mr-[10px]  border border-[#D9D9D9] checked:bg-black',
                }}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
export default Filters
